// extracted by mini-css-extract-plugin
export default {"legal":"Privacy_legal__XCRQN","root":"Privacy_root__aVwsL"};